<template>
  <section class="py-12">
    <div class="container-wrap">
      <h2 class="text-h1 mb-2">{{ t('title') }}</h2>
      <div class="flex w-full items-center justify-between">
        <div class="w-full tablet:w-1/2 tablet:pr-4">
          <h3 class="text-h3 mb-6 mt-4">{{ industryNews.title }}</h3>
          <p class="mb-6 max-h-[310px] overflow-hidden text-gray-600">
            {{ industryNews.description }}
          </p>
          <TheButton
            class="w-[180px]"
            :to="industryNews.pageUrl"
            :title="t('item-button')"
          >
            <span class="text-sm">{{ t('item-button') }}</span>
          </TheButton>
        </div>
        <div v-if="!isMobile" class="w-1/2">
          <figure class="relative aspect-video w-full overflow-hidden rounded">
            <img
              :src="industryNews.imageUrl"
              alt="industry-news-banner"
              loading="lazy"
              class="pointer-events-none absolute block h-full w-full object-cover"
            />
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  const { t } = useI18n({ useScope: 'local' });
  const { isMobile } = useScreen();

  const newsStore = useNewsStore();
  const { industryNews } = storeToRefs(newsStore);
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "Industry News You Must Know",
    "item-button": "Learn more"
  },
  "en-jp": {
    "title": "Industry News You Must Know",
    "item-button": "Learn more"
  },
  "en-tw": {
    "title": "Industry News You Must Know",
    "item-button": "Learn more"
  },
  "en-kr": {
    "title": "Industry News You Must Know",
    "item-button": "Learn more"
  },
  "en-americas": {
    "title": "Industry News You Must Know",
    "item-button": "Learn more"
  },
  "en-asia-pacific": {
    "title": "Industry News You Must Know",
    "item-button": "Learn more"
  },
  "en-emea": {
    "title": "Industry News You Must Know",
    "item-button": "Learn more"
  },
  "ja-jp": {
    "title": "業界ニュース",
    "item-button": "さらに詳しく"
  },
  "zh-cn": {
    "title": "热点资讯",
    "item-button": "了解更多"
  },
  "zh-tw": {
    "title": "精選產業消息",
    "item-button": "了解更多"
  }
}
</i18n>
